import { Box, styled, Typography } from '@mui/material';
import { Sparkles } from 'lucide-react';

export const AssistantHeader = () => (
  <Header>
    <TitleRow>
      <Avatar>
        <Sparkles size={14} color="#ffffff" />
      </Avatar>
      <Box>
        <Title>A.I. Medicare Copilot</Title>
        <Subtitle>Ask anything</Subtitle>
      </Box>
    </TitleRow>
  </Header>
);

const Header = styled(Box)({
  padding: '12px 20px',
  borderBottom: '1px solid #f1f5f9',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  flexShrink: 0,
});

const TitleRow = styled(Box)({
  display: 'flex',
  alignItems: 'center',
  gap: 12,
});

const Avatar = styled(Box)({
  width: 28,
  height: 28,
  borderRadius: '50%',
  background: 'linear-gradient(135deg, #3b82f6 0%, #9333ea 100%)',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  flexShrink: 0,
  boxShadow: '0 1px 3px rgba(0,0,0,0.15)',
});

const Title = styled(Typography)({
  fontSize: '0.875rem',
  fontWeight: 700,
  color: '#111827',
  lineHeight: 1,
});

const Subtitle = styled(Typography)({
  fontSize: '0.625rem',
  color: '#6b7280',
  marginTop: 4,
  lineHeight: 1,
});
